import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import { ErrorIcon } from 'shared-library/dist/components/material-icon';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
  },
  message: {
    padding: '0 10px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const ErrorMessage = ({
  message,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <ErrorIcon color="error" />
      <Typography
        classes={{
          root: styles.message,
        }}
        component="span"
        color="error"
      >
        {message}
      </Typography>
    </div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;
